export interface Marketplace {
  id: string;
  name: string;
  description: string;
  domain_names: string[];
}

export const getMarketplaceName = (marketplaces: Marketplace[], marketplaceId: string | undefined) => {
  return marketplaces.find((marketplace) => marketplace.id === marketplaceId)?.name ?? 'Public';
};
